import { render, staticRenderFns } from "./_EditorProfileForm.vue?vue&type=template&id=72800780&"
import script from "./_EditorProfileForm.vue?vue&type=script&lang=ts&"
export * from "./_EditorProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./_EditorProfileForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports